import CategoryPageRenderer from "@/components/CategoryPageRenderer";
export default function EGuideMateri() {
  return <CategoryPageRenderer pageKey="e-guide-materi" />;
}
